import { render, staticRenderFns } from "./CSwitch.vue?vue&type=template&id=56eccbce&scoped=true"
import script from "./CSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./CSwitch.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CSwitch.vue?vue&type=style&index=0&id=56eccbce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eccbce",
  null
  
)

export default component.exports